import { Link } from "react-router-dom";
import { imgLogoEst, imgLogoPrs } from "../../assets/img"
import { IoIosMail } from "react-icons/io";
import { FaLinkedin, FaPhoneAlt } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";

const FooterDefault = () => {
  return (
    <>
      <footer className="px-6 lg:px-14 xl:px-24 2xl:px-32 bg-black text-white absolute w-full">
        <div className="flex py-10   flex-col sm:flex-row justify-between sm:items-end w-full">
          <div className="flex flex-col gap-2">
            <Link to="/home" className="w-48 flex items-end gap-1">
              <div className="w-12">
                <img
                  src={imgLogoEst}
                  alt="Logo EST"
                  className="w-full object-contain"
                />
              </div>
              <div className="w-12">
                <img
                  src={imgLogoPrs}
                  alt="Logo PRS"
                  className="w-full object-contain"
                />
              </div>
            </Link>

            <p className="text-xl font-bold">EVER SHINE GROUP</p>

            <div className="flex justify-between gap-8">
              <div>
                <h4 className="font-bold mb-2">Headquarter:</h4>
                <p>Jl. H. Fachruddin No.16</p>
                <p>Jakarta 10250, Indonesia</p>
                <p className="mt-2">📞 +62 (21) 316 0238</p>
                <p>📠 +62 (21) 316 0260</p>
                <p>📧 info@evershinetex.com</p>
              </div>

              <div>
                <h4 className="font-bold mb-2">Factory:</h4>
                <p>Jl. Aria Jaya Santika</p>
                <p>Kab. Tangerang, Indonesia</p>
                <p className="mt-2">📞 +62 (21) 599 1612</p>
                <p>📠 +62 (21) 599 1614</p>
                <p>📧 info@evershinetex.com</p>
              </div>
            </div>
          </div>

          <div>
            <span className="text-xl font-bold mb-3">CONTACT</span>

            <ul className="space-y-4">
              <li>
                <p className="flex gap-2 items-center">
                  <IoIosMail className="w-4 h-4" />
                  <span>info@evershinetex.com</span>
                </p>
              </li>

              <li>
                <p className="flex gap-2 items-center">
                  <FaPhoneAlt className="w-3 h-3" />
                  <span>+6221-316 0238</span>
                </p>
              </li>
              <li>
                <a
                  target="_blank"
                  href={process.env.VITE_INSTAGRAM_EST}
                  className="flex gap-2 items-center"
                >
                  <AiFillInstagram className="w-4 h-4" />
                  <span className="hover:underline cursor-pointer">
                    Instagram
                  </span>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href={process.env.VITE_LINKEDIN_EST}
                  className="flex gap-2 items-center"
                >
                  <FaLinkedin className="w-4 h-4" />
                  <span className="hover:underline cursor-pointer">
                    Linkedin
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <p className="text-center mt-4 p-6">
          © {new Date().getFullYear()} EVER SHINE GROUP.
        </p>
      </footer>
    </>
  );
};

export default FooterDefault;
